import { useDispatch } from 'react-redux';
import { useCallback } from 'react';
import { openContextMenu } from '@actions/ui';
import { ContextMenuTarget } from '@reducers/ui/contextMenu';

export const useContextMenu = ({
  target,
  handler,
  params,
  disabled,
}: // disabled? -> if disabled, conditionally wrap body of handler passed to useCallback
{
  target: ContextMenuTarget;
  handler?: () => void;
  params?: Record<string, any>;
  disabled?: boolean;
}) => {
  const dispatch = useDispatch();
  const onContextMenu = useCallback(
    (e) => {
      if (!disabled) {
        e?.preventDefault();
        handler?.();
        dispatch(
          openContextMenu({
            target,
            coords: { x: e.pageX, y: e.pageY },
            viewportDimensions: { width: window.innerWidth, height: window.innerHeight },
            params: params || {},
          }),
        );
      }
    },
    [target, handler],
  );

  return onContextMenu;
};
